<template>
  <div class="waterfall clearfix worklist" id="waterfall">
    <waterfall
      :col="col"
      :width="itemWidth"
      :gutterWidth="gutterWidth"
      :key="gutterWidth"
      :data="listData"
      @loadmore="loadmore"
    >
      <template>
        <a
          class="workitem"
          href="javascript:;"
          v-for="item in listData"
          :key="item.id"
          @click="goDetail(item.id)"
        >
          <div class="pic-wrap">
            <van-image
              class="pic"
              v-if="item.image"
              lazy-load
              :src="item.image"
            />
            <div class="vote-num" v-if="detail.is_vote == 1">
              票数 {{ item.vote_num }}
            </div>
            <div class="my-sta" v-if="isMyworks && item.audit_status != 1">
              {{ worksStatus[item.audit_status] }}
            </div>
          </div>
          <div class="txt-wrap">
            <div class="user">
              <img class="avatar" :src="item.avatar" />
              <div class="nickname">{{ item.nickname }}</div>
            </div>
            <div class="time">{{ item.add_time }}</div>
          </div>
        </a>
      </template>
    </waterfall>
  </div>
</template>

<script>
export default {
  props: {
    listData: {
      type: Array,
    },
    status: {
      type: Boolean,
    },
  },
  data() {
    return {
      id: this.$route.params.id,
      col: 2,
      // itemWidth: 330,
      // gutterWidth: 20,
      // loadDistance: 100,
      isShowLightbox: false,
      isGroupImg: false,
      detail: {},
      curImgList: [],
      workList: [],
      // 如果是我的作品，传入worksid mid gid
      worksId: "",
      isShowEdit: false,
      worksStatus: ["审核中", "审核通过", "审核未通过"],
      isMyworks: false,
      // isWorksEmpty: false
    };
  },
  computed: {
    itemWidth() {
      return 358 * 0.5 * (document.documentElement.clientWidth / 375);
    },
    gutterWidth() {
      return 8 * 0.5 * (document.documentElement.clientWidth / 375);
    },
  },
  watch: {
    listData: {
      immediate: true,
      handler(val) {
        this.workList = val;
        // this.isWorksEmpty = this.workList.length == 0;

        // setTimeout(() => {
        //   this.isWorksEmpty = val.length == 0;
        // }, 1000);
      },
    },
  },
  methods: {
    // scroll() {
    //   // this.loadmore();
    //   console.log(1);
    // },
    // switchCol(col) {
    //   this.col = col;
    //   // console.log(this.col);
    // },
    init() {
      this.tools.detail_cache({ id: this.id }, true).then((res) => {
        Object.assign(this.detail, res);
        console.log(this.detail);
      });

      this.isMyworks = this.$route.name == "myworks";
      // console.log(area[this.province[0]]);
    },
    loadmore() {
      this.$emit("useGetData");
      // console.log("works", this.listData);
      // this.worksList = this.worksList.concat(this.listData);
      // this.$waterfall.forceUpdate();
    },
    lightbox(item) {
      // console.log(item);
      if (item.m_id != undefined && item.group != undefined) {
        this.editId.work_id = item.id;
        this.editId.m_id = item.m_id;
        this.editId.group = item.group;
        this.editId.link = item.editlink;
      }
      this.curImgList = item.images;
      this.isShowLightbox = true;
    },
    goDetail(id) {
      // console.log(this.status);
      if (this.status) {
        this.$router.push({
          name: "info",
          params: {
            workid: id,
          },
          query: {
            myworks: 1,
          },
        });
      } else {
        this.$router.push({
          name: "info",
          params: {
            workid: id,
          },
        });
      }
    },
    changeDisplay() {
      this.isShowLightbox = false;
    },
  },
  created() {
    // console.log("waterfall: ", this.listData);
    // if (document.querySelector("body").clientWidth <= 1600) {
    //   this.itemWidth = 285;
    // }
    // console.log(this.$route, this.$router)
    this.init();
    this.loadmore();
    // console.log(138 * 0.5 * (document.documentElement.clientWidth / 375));
    // this.worksList = this.listData;
    // this.$waterfall.forceUpdate();
  },
};
</script>

<style>
.waterfall .box {
  position: relative;
}
</style>
